import Home from "../views/Home.vue";
import Orders from "../views/Orders.vue";
import Order from "../views/Order.vue";
import Customers from "../views/Customers.vue";
import Products from "../views/Products.vue";
import Product from "../views/Product.vue";
import Categories from "../views/Categories.vue";
import Welcome from "../views/Welcome.vue";
import Support from "../views/Support.vue";
import Settings from "../views/Settings.vue";
import OnlineStore from "../views/OnlineStore/index.vue";
import Inbox from "../views/Inbox/Inbox.vue";
import StoreMainSettings from "../views/OnlineStore/MainSettings.vue";
import StoreSocialSettings from "../views/OnlineStore/SocialSettings.vue";
import StoreSeoSettings from "../views/OnlineStore/SeoSettings.vue";
import ThemeSettings from "../views/OnlineStore/ThemeSettings.vue";
import Bills from "../views/Bills.vue";

import DeliveryAreas from "../views/DeliveryAreas.vue";
import Coupons from "../views/Coupons.vue";

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta :{
            requiresAuth: false,
            requiresGuest: true,
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta :{
            title: 'الصفحة الرئيسية',
            requiresAuth: true
        }
    },
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        meta :{
            title: 'العملاء',
            requiresAuth: true
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: Orders,
        meta :{
            title: 'الطلبات',
            requiresAuth: true
        }
    },
    {
        path: '/orders/:id',
        name: 'order',
        component: Order,
        meta :{
            title: 'صفحة الطلب',
            requiresAuth: true
        }
    },
    {
        path: '/products',
        name: 'products',
        component: Products,
        meta :{
            title: 'المنتجات',
            requiresAuth: true
        }
    },
    {
        path: '/products/:id',
        name: 'product',
        component: Product,
        meta :{
            title: 'صفحة المنتج',
            requiresAuth: true
        }
    },
    {
        path: '/categories',
        name: 'categories',
        component: Categories,
        meta :{
            title: 'الأقسام',
            requiresAuth: true
        }
    },
    {
        path: '/delivery-areas',
        name: 'delivery-areas',
        component: DeliveryAreas,
        meta :{
            title: 'مناطق التوصيل',
            requiresAuth: true
        }
    },
    {
        path: '/coupons',
        name: 'coupons',
        component: Coupons,
        meta :{
            title: 'كوبونات الخصم',
            requiresAuth: true
        }
    },
    {
        path: '/inbox',
        name: 'inbox',
        component: Inbox,
        meta :{
            title: 'البريد الوارد',
            requiresAuth: true
        }
    },
    {
        path: '/store',
        name: 'store',
        component: OnlineStore,
        meta :{
            title: 'المتجر الإلكتروني',
            requiresAuth: true
        }
    },
    {
        path: '/bills',
        name: 'bills',
        component: Bills,
        meta :{
            title: 'الدفع والفواتير',
            requiresAuth: true
        }
    },
    {
        path: '/store/settings/main',
        name: 'store-main-settings',
        component: StoreMainSettings,
        meta :{
            title: 'إعدادات المتجر اﻷساسية',
            requiresAuth: true
        }
    },
    {
        path: '/store/settings/theme',
        name: 'store-theme-settings',
        component: ThemeSettings,
        meta :{
            title: 'إعدادات المظهر وواجهة المتجر',
            requiresAuth: true
        }
    },
    {
        path: '/store/settings/social',
        name: 'store-social-settings',
        component: StoreSocialSettings,
        meta :{
            title: 'إعدادات حسابات التواصل الاجتماعي',
            requiresAuth: true
        }
    },
    {
        path: '/store/settings/seo',
        name: 'store-seo-settings',
        component: StoreSeoSettings,
        meta :{
            title: 'إعدادات SEO (محركات البحث)',
            requiresAuth: true
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta :{
            title: 'اﻹعدادات',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import("../views/Login.vue"),
        meta :{
            title: 'تسجيل الدخول',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import("../views/Register.vue"),
        meta :{
            title: 'إنشاء حساب جديد',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import( '../views/ResetPassword.vue'),
        meta :{
        title: 'استعادة كلمة المرور',
        requiresAuth: false,
        requiresGuest: true,
        }
    },
    {
    path: '/confirm',
    name: 'confirm',
    component: () => import( '../views/Confirm.vue'),
    meta :{
        title: 'تأكيد البريد الإلكتروني',
        requiresAuth: true,
    }
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/About.vue"),
        meta: {
            footer: {
                show: true,
            },
            title: 'اعرف أكثر عنا'
        }
    },
    {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: () => import("../views/About.vue"),
        meta: {
            footer: {
                show: true,
            },
            title: 'سياسة الخصوصية',
        }
    },
    {
        path: "/help",
        name: "help",
        component: Support,
        meta: {
            title: 'المساعدة',
            footer: {
                show: true,
                notFixed: true,
            },
        }
    },
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'الصفحة غير موجودة',
            footer: {
                show: true,
            },
            backIcon: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
    }
  ];


  export default routes;